<template>
  <div>
    <v-card-text>
      <v-form ref="form" v-model="formValid">
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
            <strong>¡IMPORTANTE!</strong>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            El informe solo podrá generarse dentro de un rango de 90 días.
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
            <v-dialog
              ref="dialog"
              v-model="modal"
              persistent
              width="300px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="processedDocsData.dateRange"
                  label="Rango de fechas"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                  :error-messages = "dateRangeErrorMessage"
                  :rules="ruleTimestap"
                />
              </template>

              <v-date-picker
                v-model="processedDocsData.dateRange"
                range
                :min="minDate"
                :max="maxDate"
                :disabled-dates="disabledDates"
                @input="onDateRangeInput"
              >
                <v-row justify="end">
                  <v-btn
                    text
                    style="background-color: gray; color: white !important"
                    @click="modal = false"
                    class="mr-2"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    style="background-color: rgb(204 33 40); color: white !important"
                    @click="onAccept"
                  >
                    OK
                  </v-btn>
                </v-row>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              ref="Nit"
              v-model="processedDocsData.email"
              label="Correo"
              counter
              maxlength="80"
              prepend-inner-icon="mdi-email"
              required
              :rules="ruleEmail"
            />
          </v-col>

        </v-row>

        <v-row>
          <v-col
            cols="12"
          >
            <v-alert
              v-if="showAlert"
              :type="alertType"
              dense
              outlined
              border="left"
              colored-border
              class="my-4"
            >
              {{ alertMessage }}
            </v-alert>
          </v-col>
        </v-row>

        <v-card-actions class="justify-end">
          <v-btn
            :disabled="!formValid || isLoading"
            :loading="isLoading"
            style="background-color: rgb(204 33 40); color: white !important;"
            @click="generateReport"
          >
            <v-icon left>mdi mdi-email-fast-outline</v-icon>
            Generar
          </v-btn>

          <v-btn
            color="gray"
            @click="clearForm"
            :disabled="isLoading"
          >
            Limpiar
          </v-btn>
        </v-card-actions>

      </v-form>
    </v-card-text>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios';
import { environment } from '@/data/environment';
export default {
  name: 'pendingDocsFilter',
  props: ['idCompany', 'nameCompany', 'cleanData'],

  data () {
    return {
      modal: false,
      formValid: false,
      processedDocsData: [],
      dateRangeErrorMessage: [],
      isLoading: false,
      ruleEmail: [
                v => !!v || 'Este campo es obligatorio',
                v => /.+@.+\..+/.test(v) || 'El correo no es válido'
              ],
      ruleTimestap: [
                  v => !!v || 'Este campo es obligatorio'
                ],
      showAlert: false,
      alertMessage: '',
      alertType: 'success',
    }
  },
  computed: {
    minDate() {
      const today = new Date()
      const minDate = new Date(today)
      minDate.setDate(today.getDate() - 90)
      return minDate.toISOString().split('T')[0]
    },
    maxDate() {
      const today = new Date()
      return today.toISOString().split('T')[0]
    },
    disabledDates() {
      const minDate = this.minDate;
      return (date) => {
        const dateString = date.toISOString().split('T')[0];
        return dateString < minDate;
      };
    },
  },
  watch:
    {
      cleanData(newVal) {
        if (newVal) {
          this.clearForm()
          this.successAlert = false
          this.errorAlert = false
        }
      },
    },
  methods: {
    clearForm() {
      this.$refs.form.reset()
      this.dateRangeErrorMessage = []
      this.formHasErrors = null
    },
    async submitForm() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) return; // no hace nada si hay errores

      this.isLoading = true;
      try {
        await this.generateReport();
      } finally {
        this.isLoading = false;
      }
    },
    async generateReport() {
      this.resetAlert();

      if (!this.processedDocsData.dateRange || this.processedDocsData.dateRange.length === 0) {
        this.setAlert('warning', 'Por favor selecciona una una fecha de consulta.');
        return;
      }

      if (!this.processedDocsData.email) {
        this.setAlert('warning', 'Agrega un correo para enviar el informe.');
        return;
      }

      this.isLoading = true;

      try {
        const response = await axios.post(`${environment.HIOPOSWEBSERVICES}/api/sendCanTransactionsFromEmail`, {
          timestamp: this.processedDocsData.dateRange,
          email: this.processedDocsData.email,
          idCompany: this.idCompany,
          nameCompany: this.nameCompany,
          allCompanies: false
        });

        const data = response.data;
        console.log(data);
        
        if (data.Error) {
          throw new Error('Respuesta inválida del servidor.');
        }

        this.setAlert('success', 'Reporte generado exitosamente, en unos minutos llegar el reporte a la bandeja del correo.');
        this.clearForm();

      } catch (error) {
        console.error('Error al descargar XMLs:', error);
        this.setAlert('error', 'Ocurrió un error durante la descarga.');
      } finally {
        this.isLoading = false;
      }
    },
    onDateRangeInput(dateRange) {
      if (dateRange && dateRange.length === 2) {
        const startDate = new Date(dateRange[0])
        const endDate = new Date(dateRange[1])
        const diffInDays = (endDate - startDate) / (1000 * 3600 * 24)

        if (diffInDays >= 90) {
          this.processedDocsData.dateRange = [dateRange[0], this.addDays(new Date(dateRange[0]), 90)]
        }
      }
    },
    addDays(date, days) {
      const newDate = new Date(date)
      newDate.setDate(date.getDate() + days)
      return newDate.toISOString().split('T')[0]
    },
    onAccept() {
      this.modal = false
    },
    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },
    resetAlert() {
      this.alertMessage = '';
      this.alertType = 'success';
      this.showAlert = false;
    },
  },
}
</script>
